module.exports = __webpack_public_path__ + "static/arrayelems-612842e9de5cbafb4a265f8a9414edb6.png";